import React from 'react';

export const PackageDetailsStep = ({
  formData,
  errors,
  onChange,
  isEditMode,
  onNext,
  onCancel
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onNext();
  };

  return (
    <form onSubmit={handleSubmit} className="pkg-step-form fade-in">
      <div className="pkg-card">
        <div className="pkg-card-header">
          <div className="pkg-card-header-icon">①</div>
          <div>
            <h3 className="pkg-card-title">Package Identification & Metadata</h3>
            <p className="pkg-card-desc">
              Define the commercial title, clinical description, and display order for this health package.
            </p>
          </div>
        </div>

        <div className="pkg-card-body">
          {/* Row 1: Package Name (Prominent) */}
          <div className="pkg-form-group full-width">
            <label className="pkg-label required" htmlFor="pkg-name">
              Package Name
            </label>
            <input
              id="pkg-name"
              type="text"
              className={`pkg-input pkg-input-lg ${errors.packageName ? 'is-invalid' : ''}`}
              placeholder="e.g. Executive Full Body Health Checkup, Diabetic Comprehensive Care"
              value={formData.packageName}
              onChange={(e) => onChange('packageName', e.target.value)}
              autoFocus
            />
            {errors.packageName ? (
              <span className="pkg-field-error">{errors.packageName}</span>
            ) : (
              <span className="pkg-field-hint">
                The primary title displayed on patient receipts, price lists, and test selection menus.
              </span>
            )}
          </div>

          {/* Row 2: Package Code & Display Order */}
          <div className="pkg-form-grid-2">
            <div className="pkg-form-group">
              <label className="pkg-label required" htmlFor="pkg-code">
                Package Code
              </label>
              <input
                id="pkg-code"
                type="text"
                className={`pkg-input ${errors.packageCode ? 'is-invalid' : ''}`}
                placeholder="e.g. PKG_EXEC_FULL, PKG_DIAB_CARE"
                value={formData.packageCode}
                onChange={(e) => onChange('packageCode', e.target.value.toUpperCase())}
                disabled={isEditMode}
              />
              {errors.packageCode ? (
                <span className="pkg-field-error">{errors.packageCode}</span>
              ) : (
                <span className="pkg-field-hint">
                  Unique enterprise billing identifier (cannot be modified after creation).
                </span>
              )}
            </div>

            <div className="pkg-form-group">
              <label className="pkg-label" htmlFor="pkg-order">
                Display / Listing Order
              </label>
              <input
                id="pkg-order"
                type="number"
                min="0"
                className="pkg-input"
                placeholder="0"
                value={formData.displayOrder}
                onChange={(e) => onChange('displayOrder', e.target.value)}
              />
              <span className="pkg-field-hint">
                Order priority in registration dropdowns (lower numbers appear first).
              </span>
            </div>
          </div>

          {/* Row 3: Description */}
          <div className="pkg-form-group full-width">
            <label className="pkg-label" htmlFor="pkg-desc">
              Package Description & Patient Fasting / Preparation Notes
            </label>
            <textarea
              id="pkg-desc"
              rows="3"
              className="pkg-textarea"
              placeholder="e.g. Recommended for annual health assessment. Requires 10-12 hours overnight fasting. Includes Liver, Kidney, Lipid, Sugar & CBC parameters."
              value={formData.description || ''}
              onChange={(e) => onChange('description', e.target.value)}
            />
            <span className="pkg-field-hint">
              Optional clinical guidance or preparation instructions printed or referenced during registration.
            </span>
          </div>

          {/* Row 4: Status Toggle */}
          <div className="pkg-form-group full-width">
            <label className="pkg-label">Package Operational Status</label>
            <div className="pkg-status-toggle-box">
              <label className="pkg-toggle-control">
                <input
                  type="checkbox"
                  checked={Boolean(formData.isActive)}
                  onChange={(e) => onChange('isActive', e.target.checked)}
                />
                <span className="pkg-toggle-slider"></span>
              </label>
              <div className="pkg-toggle-label-group">
                <span className={`pkg-status-text ${formData.isActive ? 'active' : 'inactive'}`}>
                  {formData.isActive ? 'Active — Available for Patient Booking & Billing' : 'Inactive — Suspended from Booking'}
                </span>
                <span className="pkg-toggle-sub">
                  Inactive packages cannot be registered on new patient bills.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="pkg-card-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" id="pkg-details-next-btn">
            Continue to Add Components →
          </button>
        </div>
      </div>
    </form>
  );
};

export default PackageDetailsStep;
